import curry from 'lodash/curry'

// creates an action from a pure action creator
export const createNamedAction = curry((name, callback) => {
  // add the name to the payload fo the action callback
  return (...args) => {
    const result = {
      ...callback(...args),
      name
    }
    // for debugging actions inside form element page
    // console.log(result)

    return result
  }
})
